/*
 * @Author: Json Chen
 * @Date: 2021-06-22 16:14:41
 * @LastEditTime: 2021-10-18 16:09:51
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/FloatingActionsBar/tools.ts
 */
import { validateLink } from 'src/constrains/LinkLibrary/tools';
import { randomNumber } from '@/src/tools/helper';
import { convertSpecificError } from 'src/constrains/SalesChannelPreviewPageComponents/tools';

export const convertFloatingBarDataToRedux = (floatingBar) => {
  return Object.assign({}, floatingBar || {}, {
    buttons: ((floatingBar || {}).buttons || []).map((b) => ({
      draggableId: randomNumber(),
      ...b,
    })),
  });
};

export const validateFloatingActionsBar = (floatingActionsBar, isPrimary) => {
  //console.log('skipValidation', skipValidation);
  const { buttons = [], enabled } = floatingActionsBar;
  const generalError = [];
  const specificError = buttons.reduce((a, b) => {
    a[b['draggableId'] + 'buttonsErr'] = [];
    return a;
  }, {});

  if (!enabled) {
    // 关闭的情况下 不显示错误信息 的图标
    return {
      hasError: false,
      specificError: specificError,
      generalError: generalError,
    };
  }

  if (isPrimary) {
    for (let i = 0; i < buttons.length; i++) {
      const b = buttons[i];
      const link = b.linkModule;
      const { result } = validateLink(link);
      if (!b.name || !b.icon || !result) {
        specificError[b['draggableId'] + 'buttonsErr'].push(
          'Link、name and icon cannot be empty.',
        );
      }
      // linkValidation({
      //   data: b.linkModule,
      //   err: specificError,
      //   suffixKey: b['draggableId'],
      // });
    }
    // console.log('buttons', buttons);
    // console.log('hasError', hasError);
    // console.log('specificError', specificError);
    // console.log('generalError', generalError);

    return {
      hasError:
        convertSpecificError(specificError).length > 0 ||
        generalError.length > 0,
      specificError: specificError,
      generalError,
    };
  } else {
    for (let i = 0; i < buttons.length; i++) {
      const b = buttons[i];

      if (!b.icon) {
        specificError[b['draggableId'] + 'buttonsErr'].push(
          'icon cannot be empty.',
        );
      }
    }
    return {
      hasError:
        convertSpecificError(specificError).length > 0 ||
        generalError.length > 0,
      specificError,
      generalError,
    };
  }
};
